import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { SanAntonioHomePage } from "@/components/SanAntonioHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/san-antonio")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "San Antonio Awnings & Commercial Shade Structures | Texas Made Shade",
      description:
        "Commercial shade structures, awnings, patio covers and motorized screens for San Antonio homes and businesses. Fabricated in Seguin. Request a quote.",
      image: hero,
      socialTitle: "San Antonio Awnings & Commercial Shade — Texas Made Shade",
      socialDescription:
        "Shade for car washes, parking, schools and storefronts, plus patio covers and retractables for San Antonio homes. Explore your project options.",
      keywords:
        "patio covers San Antonio, patio cover builders San Antonio, awnings San Antonio, awning company San Antonio, shade structures San Antonio, outdoor shades San Antonio, louvered patio covers San Antonio, insulated patio covers San Antonio, aluminum patio covers San Antonio, retractable awnings San Antonio, motorized drop screens San Antonio, sail shades San Antonio, commercial awnings San Antonio, patio enclosures San Antonio, Bexar County patio covers",
    }),
    scripts: cityHeadScripts("San Antonio", "Bexar County", {
      areaServedPlaces: [
        "Alamo Heights",
        "Stone Oak",
        "Olmos Park",
        "Terrell Hills",
        "Shavano Park",
        "Castle Hills",
        "Helotes",
        "Leon Valley",
        "Alamo Ranch",
        "Cibolo Canyons",
        "King William",
        "Southtown",
      ],
    }),
  }),
  component: SanAntonioHomePage,
});
